import dayjs from "dayjs";
import { bankRecDate as convertArrayToDayjs } from "@/views/BankReconciliation/BankRec/dates";

/** 统一参数构建：过滤空值，日期字段格式化 */
export const buildRequestParams = (base, filters = {}, dateFields = []) => {
  const params = { ...base };
  Object.entries(filters).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    if (dateFields.includes(key)) {
      const date = dayjs(value);
      if (date.isValid()) params[key] = date.format("YYYY-MM-DD");
      return;
    }
    params[key] = value;
  });
  return params;
};

export const getYearOptions = () => {
  const currentYear = new Date().getFullYear();
  const options = [];
  for (let year = currentYear; year >= currentYear - 20; year--) {
    options.push({ value: year, label: year.toString() });
  }
  return options;
};

export const formatDate = (value) =>
  convertArrayToDayjs(value)?.format("MM/DD/YYYY") ?? "";

export const formatPlainDate = (value) =>
  !value ? " " : dayjs(value).format("MM/DD/YYYY");